import type {RouteRecordRaw} from 'vue-router';

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/auth/connect/:provider/:version?',
    name: 'connect-external-provider',
    component: () => import('@/views/Connect/Connect.vue'),
  },
  {
    // @TODO - can we do this with an alias?
    path: '/integratie/:provider/:version?',
    name: 'integration-provider',
    redirect: {
      name: 'connect-external-provider',
    },
  },
];
